import { IconButton } from "@mui/material";
import React, { useMemo } from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
export default (props) => {
  function handleClick() {
    console.log("##", props.data.product);
    props.onLinkClikedForProductCrud(props.data.product.prodBean.id);
  }
  return (
    <>
      {props.data.product && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div class="left-item">{props.data.id}</div>
          <div class="right-item">
            <IconButton
              onClick={handleClick}
              color="secondary"
              sx={{ padding: 0, textAlign: "right" }}
            >
              <OpenInNewIcon />
            </IconButton>
          </div>
        </div>
      )}
    </>
  );
};
